import React from "react";
import Skills from "./Skills.pc";
import Translation from "./../Translation/Translation.pc";
import styles from "./Desc.pc.module.scss";

import Benefits from "../Benefits/Benefits.pc";
import "react-quill/dist/quill.snow.css";

export default function Desc({ data, countryKey, transData }) {
  const isJp = countryKey === "jp";
  return (
    <div className={styles.descContentWrap}>
      {data.identity_restrictions?.length ? (
        <p className={styles.identity}>
          <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <rect width='24' height='24' rx='6' fill='#3CEAF6' />
            <path
              d='M11.1429 9.6673C11.1429 10.9125 10.1334 11.922 8.88817 11.922C7.64293 11.922 6.63347 10.9125 6.63347 9.6673C6.63347 8.42206 7.64293 7.4126 8.88817 7.4126H11.1429V9.6673Z'
              fill='black'
            />
            <path
              d='M12.9736 16.5875C13.0396 16.5875 13.0937 16.535 13.0937 16.469C13.0937 14.1463 11.2108 12.2634 8.88817 12.2634C6.56551 12.2634 4.68262 14.1463 4.68262 16.469C4.68262 16.535 4.73679 16.5875 4.80276 16.5875H12.9736Z'
              fill='black'
            />
            <path
              d='M17.3662 8.4751L19.3178 8.4751'
              stroke='black'
              strokeWidth='2.1'
              strokeLinecap='round'
            />
            <path
              d='M17.3662 12.4595L19.3178 12.4595'
              stroke='black'
              strokeWidth='2.1'
              strokeLinecap='round'
            />
          </svg>

          {data.identity_description}
        </p>
      ) : null}
      <div className={styles.descContent}>
        <div className={styles.descTitle}>
          <h3>{data.title}</h3>
          <Translation aiTranslate={data.aiTranslate} />
        </div>

        <Benefits data={data.benefits_info} />

        {data.description_html ? (
          <div className={styles.richText}>
            <h4>{data.description_title}</h4>
            <div
              className='ql-editor'
              dangerouslySetInnerHTML={{
                __html: transData.isOriginal ? data.description_html : data.translationDescription
              }}
            />
          </div>
        ) : null}
        {data.requirement_html ? (
          <div className={styles.richText}>
            <h4>{data.requirement_title}</h4>
            <div
              className='ql-editor'
              dangerouslySetInnerHTML={{
                __html: transData.isOriginal ? data.requirement_html : data.translationRequirements
              }}
            />
          </div>
        ) : null}

        {Object.keys(data?.extraInfo ?? {}).some((el) => data?.extraInfo?.[el]) ? (
          <div className={styles.extraInfo}>
            {data?.extraInfo?.work_time ? (
              <div className={styles.row}>
                <span className={styles.label}>{data?.extraInfo?.work_time?.key}</span>
                <p>
                  {/* {data?.extraInfo?.work_time?.value?.work_time_type_value ? (
                    <span style={{ marginBottom: 0 }}>
                      {data?.extraInfo?.work_time?.value?.work_time_type_value}
                    </span>
                  ) : null}
                  {data?.extraInfo?.work_time?.value?.work_time_range ? (
                    <span style={{ marginBottom: 0 }}>
                      {data?.extraInfo?.work_time?.value?.work_time_range}
                    </span>
                  ) : null}
                  {data?.extraInfo?.work_time?.value?.work_time_type_description ? (
                    <span style={{ marginBottom: 0 }}>
                      {data?.extraInfo?.work_time?.value?.work_time_type_description}
                    </span>
                  ) : null} */}
                  {data?.extraInfo?.work_time?.work_time_text}
                </p>
              </div>
            ) : null}
            {data?.extraInfo?.holiday ? (
              <div className={styles.row}>
                <span className={styles.label}>{data?.extraInfo?.holiday?.key}</span>
                {/* <p>
                  {data?.extraInfo?.holiday?.value?.map((item, i) => (
                    <span key={i}>{item}</span>
                  ))}
                </p> */}
                <p>{data?.extraInfo?.holiday?.value_text}</p>
              </div>
            ) : null}
            {data?.extraInfo?.insurance ? (
              <div className={styles.row}>
                <span className={styles.label}>{data?.extraInfo?.insurance?.key}</span>
                {/* <p>
                  {data?.extraInfo?.insurance?.value?.map((item, i) => (
                    <span key={i}>{item}</span>
                  ))}
                </p> */}
                <p>{data?.extraInfo?.insurance?.value_text}</p>
              </div>
            ) : null}
            {data?.extraInfo?.contract ? (
              <div className={styles.row}>
                <span className={styles.label}>{data?.extraInfo?.contract?.key}</span>
                <p>{data?.extraInfo?.contract?.value}</p>
              </div>
            ) : null}
            {data?.extraInfo?.smoking ? (
              <div className={styles.row}>
                <span className={styles.label}>{data?.extraInfo?.smoking?.key}</span>
                <p>{data?.extraInfo?.smoking?.value}</p>
              </div>
            ) : null}
          </div>
        ) : null}

        <Skills data={transData.isOriginal ? data.skills : data.translationSkills} />
      </div>
    </div>
  );
}
